import { defineMessages } from 'react-intl';

export default defineMessages({
    assignedTeachers: {
        id: 'app.components.AssignedTeacher.assignedTeachers',
        defaultMessage: 'Assigned teachers'
    },
    assignTeacher: {
        id: 'app.components.AssignedTeacher.assignTeacher',
        defaultMessage: 'Assign Teacher(s)'
    }
});



// WEBPACK FOOTER //
// ./app/components/assigned-teacher-class/messages.js